import moment from 'moment';
import { MODALS } from 'common/domain/constants';

class ModalWarningDelegationController {
  constructor(EventEmitter, $translate, $state) {
    'ngInject';
    this.EventEmitter = EventEmitter;
    this.translate = $translate;
    this.state = $state;
    moment.locale('es');
  }

  $onInit() {
    this._translateText();

    if (this.isMobileApp) {
      this.floatingActionButtons = [
        {
          literal: 'GLOBALS.BUTTON_ACTION.GOTO_DELEGACION'
        }
      ];
    }
  }

  get modal() {
    return $(MODALS.WARNING_DELEGATION_MODAL);
  }

  goToUrlDestination() {
    this.onDismiss();
    this.state.go(this.urlDestination);
  }

  onDismiss() {
    this.modal.modal('hide');
  }

  _translateText() {
    this.translate('GLOBALS.FROM').then(translation => {
      this.textTranslationStartDate = translation.$$unwrapTrustedValue();

      this.translate('GLOBALS.TO').then(translation => {
        this.textTranslationEndDate = translation.$$unwrapTrustedValue();
      });
    });
  }

  getTextForStartDate() {
    let startDateFormatted = moment(this.delegation.startDate).format('dddd DD MMMM YYYY');
    return `${this.textTranslationStartDate} ${startDateFormatted}`;
  }

  getTextForEndDate() {
    let endDateFormatted = moment(this.delegation.endDate).format('dddd DD MMMM YYYY');
    return `${this.textTranslationEndDate} ${endDateFormatted}`;
  }

}

export default ModalWarningDelegationController;



// WEBPACK FOOTER //
// ./client/app/components/modalWarningDelegation/modalWarningDelegation.controller.js